<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto" />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Forgot your password?</h4>
                  <p>Please enter your username and we'll send you email(related to this account) on how to reset your password.</p>
                </div>
                <validation-observer ref="form" v-slot="{ invalid }">
                  <form @submit.prevent="sendEmail">
                    <validation-provider name="User Name" rules="required" v-slot="{ errors }">
                      <div class="mb-8">
                        <vs-input label="User Name" name="User Name" label-placeholder="User Name" v-model="form.username" class="w-full" />
                        <span class="text-danger text-sm" v-show="!!errors[0]">{{ errors[0] }}</span>
                      </div>
                    </validation-provider>
                    <vs-button type="border" to="/" class="px-4 w-full md:w-auto">Back To Login</vs-button>
                    <vs-button button="submit" id="send-otp-button" type="relief" :disabled="invalid" class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0 vs-con-loading__container">
                      Send Email
                    </vs-button>
                  </form>
                </validation-observer>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { Validator, ValidationProvider, ValidationObserver } from 'vee-validate'

const dict = {
  custom: {
    'User Name': {
      required: 'Please enter your username name',
      alpha_dash: 'Your first name may only contain alphabetic characters and underscore'
    }
  }
}

// register custom messages
Validator.localize('en', dict)

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data: () => ({
    form: { username: '' },
    loading: false
  }),
  computed: {},
  methods: {
    async sendEmail() {
      this.loading = true
      try {
        this.$vs.loading()
        const { message } = await this.$store.dispatch('auth/forgotPassword', this.form)
        this.$vs.loading.close()
        this.loading = false
        this.$router.push('/restore-password')
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch ({ message }) {
        this.loading = false
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  },
  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#send-otp-button',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#send-otp-button > .con-vs-loading')
      }
    }
  }
}
</script>
